import Holidays, { HolidaysTypes } from 'date-holidays'
import dayjs from 'dayjs'

export const HolidayChecker = ({ date, month }: { date: string; month: string }) => {
  const selectedMonth = dayjs(month)
  const hd = new Holidays('PL', '', '', { types: ['public'] })
  const holidays = hd.getHolidays().filter(h => h.type === 'public' && dayjs(h.date).month() === selectedMonth.month())
  const holidayDates = holidays.map(d => dayjs(d.date))
  const dayjsDate = dayjs(date)
  return holidayDates.some(holidayDate => holidayDate.isSame(dayjsDate))
}

export const getHolidayNamesString = (holiday: HolidaysTypes.Holiday[]) => {
  let holidayNames = ''
  holiday.forEach(h => (holidayNames += `${h.name}, `))

  return holidayNames.slice(0, -2)
}
